const TEXT_ROOT_SENTINEL = '<span data-text-root-sentinel></span>';

/**
 * Parses text content without losing whitespace at the start of the body.
 */
export function parseTextContentBody(content: string) {
  const { body } = new DOMParser().parseFromString(
    `${TEXT_ROOT_SENTINEL}${content}`,
    'text/html'
  );
  const sentinel = body.firstElementChild;
  if (sentinel?.hasAttribute('data-text-root-sentinel')) {
    sentinel.remove();
  }
  return body;
}
